import { AlertIcon, CloseIcon } from '@/components/icons';
import { Button } from './Button';
import styles from '@/styles/components/InlineAlert/style.scss';

/** In-page error message. Used for failed requests; normal actions show no confirmation. */
export function InlineAlert({ message, onDismiss }: { message: string; onDismiss?: () => void }) {
  return (
    <div role="alert" className={styles.alert}>
      <AlertIcon size={18} />
      <span className={styles.message}>{message}</span>
      {onDismiss && (
        <Button iconOnly size="sm" variant="ghost" aria-label="Dismiss" icon={<CloseIcon size={14} />} onClick={onDismiss} />
      )}
    </div>
  );
}
